import { z } from "zod";
import { opportunitySchema } from "../schemas/index.js";
/** `GET /auth/opportunities` — market-making / arb plays with per-leg orders. */
export class OpportunitiesResource {
    http;
    constructor(http) {
        this.http = http;
    }
    list(params = {}) {
        return this.http.request({
            method: "GET",
            path: "/auth/opportunities",
            endpoint: "opportunities.list",
            query: { limit: params.limit, status: params.status, opportunity_type: params.opportunity_type, model_id: params.model_id, cursor: params.cursor },
            dataSchema: z.array(opportunitySchema),
        });
    }
    /**
     * `GET /auth/opportunities/:id` — one opportunity with its legs. Observed live 2026-10-28
     * (200, or 404 `opportunity_not_found`); the list endpoint ignores an `opportunity_id` filter.
     */
    get(id) {
        return this.http.request({
            method: "GET",
            path: `/auth/opportunities/${encodeURIComponent(id)}`,
            endpoint: "opportunities.get",
            dataSchema: opportunitySchema,
        });
    }
}
//# sourceMappingURL=opportunities.js.map